import "./App.less";
import {getParameterValueFromUrl} from "./utils/utils"
import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import ChatInput from "./components/chat-input/chat-input";
import ChatWindow from "./components/chat-window/index";
import {SESSION_ID, CONFIG} from "./common/config";
import { reSetChatMsgResultAction } from "./actions/chat-msg-actions";
import { getWelcomeMsgAction } from "./actions/chat-common-actions";
import { getChatCommon, getLastResponseTime } from "./reducers/chat-common-reducer";
import { WelcomeMsg } from "./types/common-types";
import chatbotIcon from "@/assets/chatbot-icon.svg";
import ChatSuggestion from "./components/chat-suggestion/index";
import ReactHtmlParser from "react-html-parser";
import {getAppSettingTheme} from "./reducers/chat-setting-reducer";
import {applicationThemeAction} from "./actions/chat-setting-actions";
import {ThemeInfoObj} from "./types/chat-setting-types";

const inactiveTime: number = +CONFIG.INACTIVITY_TIME;
let usedChannelId = CONFIG.CHANNEL_ID;
if(getParameterValueFromUrl("channelId")) {
    usedChannelId = getParameterValueFromUrl("channelId");
}

const App: React.FC = () => {
    const dispatch = useDispatch();
    const lastResponseTime = useSelector(getLastResponseTime);
    const [lastRespTimer, setLastRespTimer] = useState(undefined);
    const welcomeMsg: WelcomeMsg = useSelector(getChatCommon);
    const appSettingTheme =useSelector(getAppSettingTheme);
    useEffect(() => {
        // localStorage.setItem("activeIndex", "0");
         // sessionStorage.setItem("needNotify", "false");
        //init submitFeedback status
        if (localStorage.getItem("submitFeedback") !== "true"){
            localStorage.setItem("submitFeedback", "false");
        }
         //init showFeedback status
        if (localStorage.getItem("needShowFeedback") !== "true"){
            localStorage.setItem("needShowFeedback", "false");
        }
        const channelId = getParameterValueFromUrl("channelId")
        if (channelId) {
            sessionStorage.setItem("channelId", channelId)
        } else {
            sessionStorage.setItem("channelId", "")
        }

        const url = getParameterValueFromUrl("url")
        if (url) {
            sessionStorage.setItem("url", url)
        } else {
            sessionStorage.setItem("url", "")
        }

        //get theme
        dispatch(applicationThemeAction())
        //get welcome message and security alter
        dispatch(getWelcomeMsgAction());
        
        // Appdynamics
        if (CONFIG.APPD) {
            // App Dynamics
            (function (config) {
                config.appKey = CONFIG.APPD_APPKEY;
                config.adrumExtUrlHttps = CONFIG.APPD_CDN
                config.beaconUrlHttps = CONFIG.APPD_BEACONURL;
                config.useHTTPSAlways = true;
                config.xd = { enable: true };
                config.spa = { "spa2": true };
                config.isZonePromise = true;

                (function (info) {
                    try {
                        info.PageView = {
                            userData: {
                                channel: usedChannelId
                            }
                        }
                    } catch (err) {
                        console.error('app dynamic error: ' + err);
                    }
                })(config.userEventInfo || (config.userEventInfo = {}))

            })(window['adrum-config'] || (window['adrum-config'] = {}));
            let scriptDom = document.createElement('script');
            scriptDom.src = CONFIG.APPD_CDN + '/adrum-latest.js';
            scriptDom.async = true;
            document.head.appendChild(scriptDom);
        }
    }, [])

    useEffect(() => {
        if (lastRespTimer) {
            clearTimeout(lastRespTimer);
        }
        let timer: any = setTimeout(() => {
            console.log(`clear conversation history date, after ${inactiveTime / 1000 / 60} minutes`);
            dispatch(reSetChatMsgResultAction());
            sessionStorage.setItem(SESSION_ID, "");

            try {
                console.log("close section");
                parent.postMessage(JSON.stringify({ action: "closeView", viewUrl: document.URL }), CONFIG.TARGET_ORIGIN);   
            } catch (error) {
                console.log("post message error")
            }
        }, inactiveTime);
        setLastRespTimer(timer);
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
            if (lastRespTimer) {
                clearTimeout(lastRespTimer);
            }
        }
    }, [lastResponseTime])

    const getColorStyle= (appSettingTheme:ThemeInfoObj) => {
        let colorStyle="linear-gradient(90deg, #ffffff 0%, #ffffff 100%)";
        if(appSettingTheme.headerColorStart&&appSettingTheme.headerColorEnd) {
            colorStyle = "linear-gradient(90deg, "+appSettingTheme.headerColorStart+" 0%, "+appSettingTheme.headerColorEnd+" 100%)";
        }
        return colorStyle;
    }
    const closeEmma = () => {
        console.log("clicked close emme button");
        parent.postMessage(JSON.stringify({action: "minusView", viewUrl: document.URL}), CONFIG.TARGET_ORIGIN);
    }
    return (
        <div className={ "emma-app"} style={appSettingTheme?{background:getColorStyle(appSettingTheme)}:{}} data-testid="emmaApp">
            <div className="emma-header">
                <div className="emma-header-icon-div">
                    {(appSettingTheme?.icon)?<img className="chatbot-icon" alt="" src={appSettingTheme.icon} />
                    :<img className="chatbot-icon" alt="" src={chatbotIcon} />
                    }
                    <div className="title">{ReactHtmlParser((appSettingTheme&&appSettingTheme.messageOne!='<p></p>\r\n')?appSettingTheme.messageOne:welcomeMsg.messageOne)}</div>
                </div>

                <div className="sub-title">{ReactHtmlParser((appSettingTheme&&appSettingTheme.messageTwo!='<p></p>\r\n')?appSettingTheme.messageTwo:welcomeMsg.messageTwo)}</div>
                <button type="button" className="close-emma" data-testid="closeEmmaIcon" onClick={closeEmma}>
                    <p></p>
                </button>
            </div>
            <div className="emma-chat" style={appSettingTheme?.background ? {backgroundImage:"url("+appSettingTheme.background+")"} : {}}>
                <ChatWindow></ChatWindow>
                <ChatSuggestion></ChatSuggestion>
                <ChatInput></ChatInput>
            </div>
        </div>
    );
};
export default App;